document.addEventListener('alpine:init', () => {
    Alpine.data('tabs', () => ({
        tabs: [],
        currentTab: null,
        isCurrent(tab) {
            return this.currentTab === tab;
        },
        register(name) {
            this.tabs.push(name);
        },
        init() {
            this.$watch('currentTab', () => {
                const elem = document.getElementById('tabs');
                if (elem) {
                    elem.scrollIntoView({behavior: 'smooth', block: 'start'});
                }
                // window.scrollTo({top: 0, behavior: 'smooth'});
            });
        },
    }));
});